import {
  getClickFeature,
  getFeature,
} from '@micro-frontend-react/employee-experience/lib/UsageTelemetryHelper';
import * as React from 'react';
import { useState } from 'react';
import { HelpContext } from '../../../shared/HelpContext';
import * as styled from './Help.styled';
import { HelpPanel } from './HelpPanel';
import { useUserProfile } from '../../../redux/hooks/userUserProfile';
import { Link } from '../../Share.styled';

export const HelpPanelBase = React.memo(function HelpPanelBaseContent(): React.ReactElement {
  const feature = getFeature('EVL', 'HelpPanel');
  const [selectedQuestion, setSelectedQuestion] = useState<string>();
  const [userProfile, isUserProfileLoading, userProfileHasError] = useUserProfile(feature);

  return (
    <>
      <HelpContext.Consumer>
        {(context) => (
          <>
            <h3>Top questions</h3>

            <div
              style={{
                marginTop: 10,
                display: 'flex',
                flexDirection: 'column',
                flexFlow: 'wrap',
                justifyContent: 'flex-start',
                alignItems: 'center',
                textAlign: 'left',
                height: 'auto',
              }}
            >
              <div
                style={{
                  textAlign: 'left',
                }}
              >
                <styled.QuestionLink
                  title={''}
                  onClick={() => {
                    setSelectedQuestion('q1');
                    context.toggleShowHelpContextPanel(true);
                  }}
                  {...getClickFeature(feature, 'Question1Link')}
                >
                  When will I receive my letter?
                </styled.QuestionLink>
              </div>
              <div style={{ textAlign: 'left' }}>
                <styled.QuestionLink
                  title={''}
                  onClick={() => {
                    setSelectedQuestion('q2');
                    context.toggleShowHelpContextPanel(true);
                  }}
                  {...getClickFeature(feature, 'Question2Link')}
                >
                  Where can I find the letter after it has been generated?
                </styled.QuestionLink>
              </div>
              <div style={{ textAlign: 'left' }}>
                <styled.QuestionLink
                  title={''}
                  onClick={() => {
                    setSelectedQuestion('q3');
                    context.toggleShowHelpContextPanel(true);
                  }}
                  {...getClickFeature(feature, 'Question3Link')}
                >
                  The information in the letter is not correct. How can I update my personal data?
                </styled.QuestionLink>
              </div>
              <div
                style={{
                  padding: '0',
                  textAlign: 'left',
                }}
              >
                <styled.QuestionLink
                  title={''}
                  style={{ height: 'auto' }}
                  onClick={() => {
                    setSelectedQuestion('q4');
                    context.toggleShowHelpContextPanel(true);
                  }}
                  {...getClickFeature(feature, 'Question4Link')}
                >
                  I need a different type of letter (for business travel or something else that’s
                  not offered here). How can I get that?
                </styled.QuestionLink>
              </div>
            </div>
            {!isUserProfileLoading && !userProfileHasError && (
              <>
                <h3 style={{ marginTop: 30 }}>Need help?</h3>
                <div style={{ textAlign: 'left', marginTop: 10 }}>
                  <Link
                    to={
                      userProfile != null && userProfile.allowedAva
                        ? __Ava_Link__
                        : __AskHR_Application__Link__
                    }
                    title="AskHR Link"
                    target="_blank"
                    usageEvent={{
                      feature: 'EVL',
                      subFeature: 'HelpPanel.AskHRLink',
                    }}
                  >
                    Contact AskHR
                  </Link>
                </div>
              </>
            )}
            <HelpPanel questionId={selectedQuestion} />
          </>
        )}
      </HelpContext.Consumer>
    </>
  );
});
